module.exports = __webpack_public_path__ + "media/images/due-icon-5c0e18b40642b81930dbd6277aa190ed.svg";